import type { WebSiteHref } from '@generalTypes/apiTypes';
import { settings } from '../../config/settings';

export const webpages = '/web/pages';
export const websites = '/web/sites';

export const webSitesProHref = `${websites}/${settings.websites.pro}` as WebSiteHref;
export const webSitesWwwHref = `${websites}/${settings.websites.www}` as WebSiteHref;
